import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { Modal, Button, Form, SelectLabel, TooltipHelp } from '@weezevent/nacre';
import { capitalizeFirstLetter } from '../../../attendee/detail/components/utils';

export default function ActionOnRatesModal({ type, selectedId, title = null, subtitle = null, onSave, onClose, options, showModal, isSubmitting = false, tooltip = null }) {
    const { t } = useTranslation();
    const [ObjectIdSelected, setObjectiId] = React.useState(selectedId || null);

    React.useEffect(() => {
        setObjectiId(selectedId);
    }, [selectedId]);

    if (!options) {
        return null;
    }

    return (
        <Modal
            open={showModal}
            onClose={onClose}
            title={title}
            subtitle={subtitle}
            submitButton={<Button primary disabled={isSubmitting} isLoading={isSubmitting} onClick={() => onSave(ObjectIdSelected)} label={t(`ticket.common.action.save`)} />}
            cancelButton={<Button onClick={onClose} label={t(`ticket.common.action.cancel`)} />}
        >
            <Form>
                <Form.Field>
                    <SelectLabel
                        value={ObjectIdSelected}
                        label={
                            <span>
                                {t(`ticket.rates.${type}`)}
                                {tooltip && <TooltipHelp title={tooltip} />}
                            </span>
                        }
                        onChange={value => setObjectiId(value)}
                        options={options}
                        placeholder={t(`ticket.rates.infos.placeholder${capitalizeFirstLetter(type)}`)}
                    />
                </Form.Field>
            </Form>
        </Modal>
    );
}

ActionOnRatesModal.propTypes = {
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    showModal: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    subtitle: PropTypes.string,
    tooltip: PropTypes.node,
    isSubmitting: PropTypes.bool
};
